import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { DICT } from "@/lib/i18n";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState(localStorage.getItem("mdg_theme") || "dark");
  const [lang, setLang] = useState(localStorage.getItem("mdg_lang") || "fr");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("mdg_theme", theme);
  }, [theme]);
  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("mdg_lang", lang);
  }, [lang]);

  useEffect(() => {
    if (!localStorage.getItem("mdg_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mdg_token", data.token);
    setUser(data.user);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("mdg_token");
    setUser(false);
  };
  const t = useCallback((k) => DICT[lang][k] || k, [lang]);
  const can = (...roles) => user && roles.includes(user.role);

  return (
    <Ctx.Provider value={{ user, login, logout, theme, setTheme, lang, setLang, t, can }}>{children}</Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
